import { mutatorAction } from 'satcheljs';
import { getStore } from '../store/store';

/* Set the suggestion in the store when selected so it can be retrieved */
export const setMaxEntries = mutatorAction(
    'SET_MAX_ENTRIES',
    function setMaxEntries(maxEntries: string) {
        const store = getStore();
        store.maxEntries = maxEntries;
    }
);
